import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/Index.vue'
import Service from '../views/Service.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      component: Index,
      name: 'Index',
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/bake',
      component: resolve => require(['@/views/Index_bake'], resolve),
      name: 'IndexBake',
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/service',
      component: Service,
      name: 'Service'
    }
    // {
    //   path: '/history',
    //   component: History
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js